import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createSlots as _createSlots, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7e58a368"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1,
  class: "button-style"
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 2
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  key: 2
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  key: 3,
  style: {
    "white-space": "pre-wrap"
  }
};
import { ref, reactive, watch, toRefs, getCurrentInstance, computed } from 'vue';
import CommonHead from './CommonHead.vue';
import { odataDateToString } from '@/utils/odataUtilCommon';
import _ from 'lodash';
import { Search } from '@element-plus/icons-vue';
import { priceFormat } from '@/utils/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'CommonForm',
  props: {
    // json schema
    schema: {
      type: Object,
      required: true
    },
    formEditable: {
      type: Boolean,
      default: true
    },
    // 页面需要显示的字段
    formSchema: {
      type: Array,
      required: false,
      default: null
    },
    // 页面属性样式
    formUiSchema: {
      type: Object,
      required: true
    },
    // 是否编辑状态
    labelMode: {
      type: Boolean,
      required: false,
      default: false
    },
    // 绑定数据
    formData: {
      type: Object,
      required: false
    },
    // 校验规则
    rules: {
      type: Object,
      required: true
    },
    // 字段宽度
    labelWidth: {
      type: String,
      required: false,
      default: '100px'
    },
    // 标签位置
    labelPosition: {
      type: String,
      required: false
    },
    // 加载中标识
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    subTitle: {
      type: String,
      required: false
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const prop = __props;
    const instance = getCurrentInstance();
    const pc = instance?.appContext?.config?.globalProperties?.$pc;
    const formCommon = reactive({
      formModel: prop.formData
    });
    const labelMode = computed(() => {
      if (!pc) return true;
      return prop.labelMode;
    });
    const {
      formModel
    } = toRefs(formCommon);
    const formRef = ref();
    const handleTelInput = (prop, newValue = '') => {
      const oldValue = formModel.value[prop] || '';
      const isDel = newValue.length < oldValue.length;
      const telRe = /^[0-9\-]+$/;
      if (telRe.test(newValue) || isDel) {
        formModel.value[prop] = newValue;
      }
    };
    const validateForm = () => {
      if (!formRef.value) return;
      return new Promise((resolve, reject) => {
        formRef.value?.validate((valid, invalidFields) => {
          console.log("🚀 ~ file: CommonForm.vue ~ line 304 ~ formRef.value?.validate ~ invalidFields", invalidFields);
          resolve(valid);
        });
      });
      //   let validateStatus = false
      //   formRef.value.validate((valid: any) => {
      //     validateStatus = valid
      //   })
      //   return validateStatus
    };
    const domainFormatValue = (value, filed) => {
      if (value === undefined || !prop.schema || !prop.schema.properties) {
        return '';
      }
      const vals = Array.isArray(value) ? value : [value];
      const listObj = prop.schema.properties[filed].oneOf;
      const texts = vals.map(val => {
        let text = '';
        const res = listObj.filter(e => e.const === val);
        if (res && res.length > 0) {
          text = res[0].title;
        }
        return text;
      });
      return texts.length === 1 ? texts[0] : texts.join(', ');
    };
    const valueInput = (formData, filed, precision) => {
      // 防止删除为空 或不为数字
      if (!formData[filed] || isNaN(formData[filed])) {
        const zearo = 0;
        formData[filed] = zearo.toFixed(precision) + '';
      }
      if (formData[filed].split('.').length > 1 && formData[filed].split('.')[1].length > precision) {
        const temp = parseInt(10 + new Array(precision).join('0'));
        formData[filed] = Math.floor(formData[filed] * temp) / temp + '';
      }
    };
    const valueInput2 = (formData, filed, precision) => {
      // 将空字符串 或不为数字置空
      if (!formData[filed] || isNaN(formData[filed])) {
        formData[filed] = '';
      }
      if (formData[filed].split('.').length > 1 && formData[filed].split('.')[1].length > precision) {
        const temp = parseInt(10 + new Array(precision).join('0'));
        formData[filed] = Math.floor(formData[filed] * temp) / temp + '';
      }
    };
    const eventBlur = item => {
      if (prop.formUiSchema[item] && prop.formUiSchema[item]['event:blur']) {
        prop.formUiSchema[item]['event:blur']();
      }
    };
    const valueToFixed = (formData, filed, precision) => {
      // 防止删除为空 或不为数字
      if (!formData[filed] || isNaN(formData[filed])) {
        const zearo = 0;
        formData[filed] = zearo.toFixed(precision) + '';
      }
      formData[filed] = parseFloat(formData[filed]).toFixed(precision) + '';
    };
    const clearFiledValidate = filed => {
      formRef.value?.clearValidate(filed);
    };
    const resetFields = () => {
      formRef.value?.resetFields();
      formRef.value?.clearValidate();
    };
    const commonDateFormatter = value => {
      if (_.isEmpty(value)) {
        return value;
      }
      return odataDateToString(value);
    };
    const isDisabled = item => {
      // 整个表单不可编辑
      if (!prop.formEditable) return true;
      const disabledTemp = prop.formUiSchema[item] && prop.formUiSchema[item]['ui:disabled'] ? prop.formUiSchema[item]['ui:disabled'] : false;
      if (prop.formUiSchema[item] && prop.formUiSchema[item]['ui:disabled'] && typeof prop.formUiSchema[item]['ui:disabled'] === 'function') {
        return prop.formUiSchema[item]['ui:disabled']();
      } else if (disabledTemp) {
        return true;
      } else if (prop.formUiSchema[item] && prop.formUiSchema[item].edit === false) {
        return true;
      }
      return false;
    };
    watch(() => prop.formData, newVal => {
      if (newVal) {
        formModel.value = newVal;
      }
    }, {
      deep: true
    });
    __expose({
      validateForm,
      clearFiledValidate,
      resetFields
    });
    return (_ctx, _cache) => {
      const _component_InfoFilled = _resolveComponent("InfoFilled");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", null, [__props.subTitle ? (_openBlock(), _createBlock(CommonHead, {
        key: 0,
        title: _ctx.$t(__props.subTitle)
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "batchControl")]),
        _: 3
      }, 8, ["title"])) : _createCommentVNode("", true), !__props.subTitle && _ctx.$slots.batchControl ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "batchControl")])) : _createCommentVNode("", true), _withDirectives((_openBlock(), _createBlock(_component_el_form, {
        class: _normalizeClass(["form-beautify-handle", _unref(pc) ? 'pc-view' : 'mobile-view']),
        ref_key: "formRef",
        ref: formRef,
        model: _unref(formModel),
        "element-loading-text": _ctx.$t('msg-loading2'),
        rules: __props.rules,
        "show-message": true,
        "label-width": __props.labelWidth,
        "label-position": __props.labelPosition,
        "hide-required-asterisk": labelMode.value,
        "validate-on-rule-change": false
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formSchema, (item, index) => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: index
            }, [(__props.formUiSchema[item] && __props.formUiSchema[item]['ui:hidden'] ? !__props.formUiSchema[item]['ui:hidden']() : true) ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: _unref(pc) ? __props.formUiSchema[item] && __props.formUiSchema[item].span ? __props.formUiSchema[item].span : 8 : 24,
              style: _normalizeStyle(__props.formUiSchema[item] && __props.formUiSchema[item]['ui:el-clo-style'] ? __props.formUiSchema[item]['ui:el-clo-style'] : '')
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                prop: item,
                "label-width": __props.formUiSchema[item]?.labelWidth || __props.labelWidth || 'auto'
              }, {
                label: _withCtx(() => [_createTextVNode(_toDisplayString(__props.schema.properties && __props.schema.properties[item] ? _ctx.$t(__props.schema.properties[item].title) + ':' : '') + " ", 1), __props.formUiSchema[item] && __props.formUiSchema[item]['tip-content'] ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  class: "box-item",
                  effect: "dark",
                  content: __props.formUiSchema[item]['tip-content'],
                  placement: "top"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, {
                    color: "#EF890C"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_InfoFilled)]),
                    _: 1
                  })]),
                  _: 2
                }, 1032, ["content"])) : _createCommentVNode("", true)]),
                default: _withCtx(() => [__props.formUiSchema[item] && __props.formUiSchema[item].slot ? _renderSlot(_ctx.$slots, item, {
                  key: 0,
                  form: _unref(formModel)
                }) : labelMode.value && __props.schema.properties && (__props.schema.properties[item].anyOf || __props.schema.properties[item].oneOf) ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t(domainFormatValue(_unref(formModel)[item], item))), 1)) : labelMode.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [__props.schema.properties && __props.schema.properties[item].format === 'date' ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(commonDateFormatter(_unref(formModel)[item])), 1)) : __props.schema.properties && __props.schema.properties[item].format === 'price' ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(priceFormat)(_unref(formModel)[item])), 1)) : __props.schema.properties && __props.schema.properties[item].format === 'html' ? (_openBlock(), _createElementBlock("span", _hoisted_6, [_createElementVNode("div", {
                  innerHTML: _unref(formModel)[item]
                }, null, 8, _hoisted_7)])) : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(formModel)[item]), 1))])) : __props.schema.properties && __props.schema.properties[item].anyOf ? (_openBlock(), _createBlock(_component_el_radio_group, {
                  key: 3,
                  modelValue: _unref(formModel)[item],
                  "onUpdate:modelValue": $event => _unref(formModel)[item] = $event,
                  disabled: isDisabled(item)
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.schema.properties[item].anyOf, itm => {
                    return _openBlock(), _createBlock(_component_el_radio, {
                      key: itm.const,
                      label: itm.const
                    }, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(itm.title)), 1)]),
                      _: 2
                    }, 1032, ["label"]);
                  }), 128))]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])) : __props.schema.properties && __props.schema.properties[item]?.oneOf ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 4,
                  modelValue: _unref(formModel)[item],
                  "onUpdate:modelValue": $event => _unref(formModel)[item] = $event,
                  style: {
                    "width": "100%"
                  },
                  clearable: "",
                  filterable: "",
                  onChange: $event => __props.formUiSchema[item] && __props.formUiSchema[item]['event:change'] ? __props.formUiSchema[item]['event:change']($event) : null,
                  placeholder: _ctx.$t(__props.schema.properties[item].quickinfo) || (__props.formUiSchema[item]?.placeholder ? _ctx.$t(__props.formUiSchema[item].placeholder) : _ctx.$t('msg-select-placeholder')),
                  disabled: isDisabled(item),
                  multiple: __props.formUiSchema[item] && __props.formUiSchema[item]['multiple'],
                  "collapse-tags": __props.formUiSchema[item] && __props.formUiSchema[item].collapseTags !== undefined ? __props.formUiSchema[item].collapseTags : true,
                  "fit-input-width": true
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.schema.properties[item]?.oneOf, option => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: option.const,
                      label: _ctx.$t(option.title),
                      value: option.const
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "placeholder", "disabled", "multiple", "collapse-tags"])) : __props.schema.properties && __props.schema.properties[item].type === 'number' ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 5,
                  modelValue: _unref(formModel)[item],
                  "onUpdate:modelValue": $event => _unref(formModel)[item] = $event,
                  type: "number",
                  style: {
                    "width": "100%"
                  },
                  "controls-position": "right",
                  maxlength: __props.formUiSchema[item]?.maxlength || '',
                  placeholder: _ctx.$t(__props.formUiSchema[item]?.placeholder) || '',
                  disabled: isDisabled(item)
                }, null, 8, ["modelValue", "onUpdate:modelValue", "maxlength", "placeholder", "disabled"])) : __props.schema.properties && __props.schema.properties[item].type === 'tel' ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 6,
                  "model-value": _unref(formModel)[item],
                  "onUpdate:modelValue": $event => handleTelInput(item, $event),
                  maxlength: __props.formUiSchema?.[item]?.maxlength || 14,
                  disabled: isDisabled(item)
                }, null, 8, ["model-value", "onUpdate:modelValue", "maxlength", "disabled"])) : __props.schema.properties && (__props.schema.properties[item].type === 'date' || __props.schema.properties[item].format === 'date') ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 7,
                  modelValue: _unref(formModel)[item],
                  "onUpdate:modelValue": $event => _unref(formModel)[item] = $event,
                  type: "date",
                  style: {
                    "width": "100%"
                  },
                  placeholder: __props.formUiSchema[item]?.placeholder ? _ctx.$t(__props.formUiSchema[item].placeholder) : _ctx.$t('msg-date-placeholder'),
                  disabled: isDisabled(item),
                  onChange: $event => __props.formUiSchema[item] && __props.formUiSchema[item]['event:change'] ? __props.formUiSchema[item]['event:change']($event) : null,
                  format: "YYYY-MM-DD",
                  "value-format": __props.formUiSchema?.[item]?.valueFormat || 'YYYY-MM-DD'
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled", "onChange", "value-format"])) : __props.schema.properties && __props.schema.properties[item].type === 'string' && __props.formUiSchema[item] && (__props.formUiSchema[item].precision || __props.formUiSchema[item].precision === 0) ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 8,
                  onInput: $event => valueInput(_unref(formModel), item, __props.formUiSchema[item].precision),
                  onBlur: $event => {
                    valueToFixed(_unref(formModel), item, __props.formUiSchema[item].precision);
                    eventBlur(item);
                  },
                  onChange: $event => __props.formUiSchema[item] && __props.formUiSchema[item]['event:change'] ? __props.formUiSchema[item]['event:change']($event) : null,
                  modelValue: _unref(formModel)[item],
                  "onUpdate:modelValue": $event => _unref(formModel)[item] = $event,
                  autocomplete: "off",
                  maxlength: __props.formUiSchema[item]?.maxlength || '',
                  "show-word-limit": __props.formUiSchema[item]?.showWordLimit || false,
                  placeholder: __props.formUiSchema[item]?.placeholder ? _ctx.$t(__props.formUiSchema[item].placeholder) : '',
                  disabled: isDisabled(item)
                }, _createSlots({
                  _: 2
                }, [__props.formUiSchema[item] && __props.formUiSchema[item].unit ? {
                  name: "append",
                  fn: _withCtx(() => [_createTextVNode(_toDisplayString(__props.formUiSchema[item].unit), 1)]),
                  key: "0"
                } : undefined]), 1032, ["onInput", "onBlur", "onChange", "modelValue", "onUpdate:modelValue", "maxlength", "show-word-limit", "placeholder", "disabled"])) : __props.schema.properties && __props.schema.properties[item].type === 'string' && __props.formUiSchema[item] && __props.formUiSchema[item]['ui:widget'] && __props.formUiSchema[item]['ui:widget'] === 'textarea' ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 9,
                  modelValue: _unref(formModel)[item],
                  "onUpdate:modelValue": $event => _unref(formModel)[item] = $event,
                  type: "textarea",
                  rows: __props.formUiSchema[item]['ui:rowspan'] ? __props.formUiSchema[item]['ui:rowspan'] : 1,
                  autocomplete: "off",
                  maxlength: __props.formUiSchema[item]?.maxlength || '',
                  "show-word-limit": __props.formUiSchema[item]?.showWordLimit || false,
                  placeholder: __props.formUiSchema[item]?.placeholder ? _ctx.$t(__props.formUiSchema[item].placeholder) : '',
                  disabled: isDisabled(item)
                }, null, 8, ["modelValue", "onUpdate:modelValue", "rows", "maxlength", "show-word-limit", "placeholder", "disabled"])) : __props.schema.properties && __props.schema.properties[item].type === 'string' && __props.formUiSchema[item] && (__props.formUiSchema[item].decimal || __props.formUiSchema[item].decimal === 0) ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 10,
                  onInput: $event => valueInput2(_unref(formModel), item, __props.formUiSchema[item].decimal),
                  onBlur: $event => {
                    valueToFixed(_unref(formModel), item, __props.formUiSchema[item].decimal);
                    eventBlur(item);
                  },
                  modelValue: _unref(formModel)[item],
                  "onUpdate:modelValue": $event => _unref(formModel)[item] = $event,
                  autocomplete: "off",
                  maxlength: __props.formUiSchema[item]?.maxlength || '',
                  "show-word-limit": __props.formUiSchema[item]?.showWordLimit || false,
                  placeholder: __props.formUiSchema[item]?.placeholder ? _ctx.$t(__props.formUiSchema[item].placeholder) : '',
                  disabled: isDisabled(item)
                }, _createSlots({
                  _: 2
                }, [__props.formUiSchema[item] && __props.formUiSchema[item].unit ? {
                  name: "append",
                  fn: _withCtx(() => [_createTextVNode(_toDisplayString(__props.formUiSchema[item].unit), 1)]),
                  key: "0"
                } : undefined]), 1032, ["onInput", "onBlur", "modelValue", "onUpdate:modelValue", "maxlength", "show-word-limit", "placeholder", "disabled"])) : __props.schema.properties && __props.schema.properties[item].type === 'string' && __props.formUiSchema[item] && __props.formUiSchema[item]['ui:click'] ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 11,
                  modelValue: _unref(formModel)[item],
                  "onUpdate:modelValue": $event => _unref(formModel)[item] = $event,
                  rows: __props.formUiSchema[item]['ui:rowspan'] ? __props.formUiSchema[item]['ui:rowspan'] : 1,
                  autocomplete: "off",
                  disabled: true,
                  maxlength: __props.formUiSchema[item]?.maxlength || '',
                  "show-word-limit": __props.formUiSchema[item]?.showWordLimit || false,
                  placeholder: __props.formUiSchema[item]?.placeholder ? _ctx.$t(__props.formUiSchema[item].placeholder) : '',
                  class: _normalizeClass(['clickInput', {
                    'hightlight-input': __props.formUiSchema[item]?.noDisabledStyle
                  }])
                }, {
                  append: _withCtx(() => [_createVNode(_component_el_button, {
                    icon: _unref(Search),
                    onClick: $event => __props.formUiSchema[item]['ui:click']()
                  }, null, 8, ["icon", "onClick"])]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue", "rows", "maxlength", "show-word-limit", "placeholder", "class"])) : (_openBlock(), _createBlock(_component_el_input, {
                  key: 12,
                  modelValue: _unref(formModel)[item],
                  "onUpdate:modelValue": $event => _unref(formModel)[item] = $event,
                  autocomplete: "off",
                  disabled: isDisabled(item),
                  maxlength: __props.formUiSchema[item]?.maxlength || __props.schema?.properties?.[item]?.maxLength || 300,
                  onChange: $event => __props.formUiSchema[item] && __props.formUiSchema[item]['event:change'] ? __props.formUiSchema[item]['event:change']($event) : null,
                  clearable: "",
                  placeholder: __props.formUiSchema[item]?.placeholder ? _ctx.$t(__props.formUiSchema[item].placeholder) : '',
                  "show-word-limit": __props.formUiSchema[item]?.showWordLimit || false
                }, _createSlots({
                  _: 2
                }, [__props.formUiSchema[item] && __props.formUiSchema[item].unit ? {
                  name: "append",
                  fn: _withCtx(() => [_createTextVNode(_toDisplayString(__props.formUiSchema[item].unit), 1)]),
                  key: "0"
                } : undefined]), 1032, ["modelValue", "onUpdate:modelValue", "disabled", "maxlength", "onChange", "placeholder", "show-word-limit"]))]),
                _: 2
              }, 1032, ["prop", "label-width"])]),
              _: 2
            }, 1032, ["span", "style"])) : _createCommentVNode("", true)], 64);
          }), 128))]),
          _: 3
        })]),
        _: 3
      }, 8, ["model", "element-loading-text", "rules", "label-width", "label-position", "hide-required-asterisk", "class"])), [[_directive_loading, __props.loading]])]);
    };
  }
});